import { cn } from "@/lib/utils";

interface SectionHeadingProps {
  eyebrow: string;
  title: string;
  description?: string;
  align?: "left" | "center";
  className?: string;
}

export const SectionHeading = ({
  eyebrow,
  title,
  description,
  align = "left",
  className,
}: SectionHeadingProps) => {
  return (
    <div
      className={cn(
        "space-y-4",
        align === "center" ? "mx-auto max-w-3xl text-center" : "",
        className,
      )}
    >
      <p className="text-xs font-semibold uppercase tracking-[0.45em] text-primary/70">
        {eyebrow}
      </p>
      <h2 className="font-display text-3xl font-semibold text-foreground md:text-4xl">
        {title}
      </h2>
      {description ? (
        <p className="text-base text-muted-foreground md:text-lg">{description}</p>
      ) : null}
    </div>
  );
};
